import * as types from './formStructureActionTypes';

const groupFormBySection = form =>
  form.reduce((acc, section) => {
    if (acc[section.showSectionC]) {
      if (acc[section.showSectionC][section.groupNumberC]) {
        acc[section.showSectionC][section.groupNumberC].push(section);
      } else {
        acc[section.showSectionC][section.groupNumberC] = [section];
      }
    } else {
      acc[section.showSectionC] = {
        [section.groupNumberC]: [section],
      };
    }
    return acc;
  }, {});

const sortForm = sections => {
  Object.keys(sections).forEach(section =>
    Object.keys(sections[section]).forEach(group => {
      sections[section][group] = sections[section][group].sort(
        (a, b) => a.orderNumberC - b.orderNumberC
      );
    })
  );
  return sections;
};

export default (
  state = {
    form: [],
    sections: {},
    optionByField: {},
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.form,
        sections: sortForm(groupFormBySection(action.form)),
      };
    case types.GET_FORM_ERROR:
      return {
        ...state,
        form: [],
        loading: false,
        error: action.error,
      };
    case types.SET_OPTIONS_BY_FIELDS:
      return {
        ...state,
        optionByField: action.optionByField,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/formStructure/formStructureReducer.js